import { render, staticRenderFns } from "./HwProtocolVersionEdit.vue?vue&type=template&id=494a60c8&scoped=true"
import script from "./HwProtocolVersionEdit.vue?vue&type=script&lang=js"
export * from "./HwProtocolVersionEdit.vue?vue&type=script&lang=js"
import style0 from "./HwProtocolVersionEdit.vue?vue&type=style&index=0&id=494a60c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a60c8",
  null
  
)

export default component.exports